import { Component } from '@angular/core';
import { ConfigService } from "./ConfigService";

@Component({
	
	template: ''
})
export class RouterComponent {
	

	constructor(
		public configData: ConfigService) {
		this.configData.goHome();
	}
		
}
